/** @module adminPathHelper */
export const ADMIN_PATH_PREFIX = '/admin/a7Hcd2jsEwS849xKSgEDXL'

export const adminPathBuilder = (path) => ADMIN_PATH_PREFIX + path
export const adminPathHome = () => adminPathBuilder('/usuarios')
export const adminPathPayments = () => adminPathBuilder('/pagamentos')
export const adminPathEmails = () => adminPathBuilder('/emails')
export const adminPathActiveContracts = () => adminPathBuilder('/contratos-ativos')
export const adminPathAds = () => adminPathBuilder('/newdash/property/ads')
